import { IBoundary } from '../../../helpers/hooks/fishrules/useRegulationBoundaryAtLocation';
import { useSpeciesAtLocation } from '../../../helpers/hooks/fishrules/useSpeciesAtLocation';
import { getAdditionalInformation } from '../../../helpers/regulations/getAdditionalInformation';
import { isProhibitedLocation } from '../../../helpers/regulations/isProhibitedLocation';
import { ICoordinates } from '../../../interfaces/geo';
import { Accordion, IAccordionData } from '../../Accordion/Accordion';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import { RegulationCards } from '../../RegulationCards/RegulationCards';

export interface ISpeciesRegulationsProps {
  boundaries: IBoundary[] | undefined;
  coordinates: ICoordinates;
  fishrulesSpeciesId: number;
}

export const SpeciesRegulations = ({
  boundaries,
  coordinates,
  fishrulesSpeciesId,
}: ISpeciesRegulationsProps) => {
  const { isLoading: areSpeciesLoading, species } = useSpeciesAtLocation(
    coordinates && fishrulesSpeciesId ? { fishrulesSpeciesId, ...coordinates } : undefined,
  );

  const { isProhibited, message } = isProhibitedLocation(boundaries || []);

  const blocksData: IAccordionData[] = [];
  if (species && boundaries) {
    const additionalInformation = getAdditionalInformation({ species, boundaries });
    additionalInformation.forEach(({ visible, title: additionaTitle, body }) => {
      if (visible) {
        blocksData.push({ title: additionaTitle, body, id: additionaTitle });
      }
    });
  }

  if (areSpeciesLoading) {
    return <LoadingSpinner loadingText="Loading regulations for the selected species..." />;
  }

  if (!species) {
    return <></>;
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-3">
        <RegulationCards
          coordinates={coordinates}
          species={species}
          infoCardSize="lg"
          isProhibitedLocation={isProhibited}
          prohibitedMessage={message}
        />
      </div>
      <div className="mt-10 grid grid-cols-12 gap-4 sm:grid-cols-4 md:grid-cols-12">
        <Accordion
          className="bg-sea-foam col-span-full sm:col-span-3 md:col-span-full"
          blocksData={blocksData}
          blockClassName="overflow-auto!"
        />
      </div>
    </>
  );
};
